import { StepSubtitle } from './StepSubtitle';
import { useName } from '../hooks/useName';
import { jsx as _jsx } from "react/jsx-runtime";
export const NameSubtitle = ({
  translation
}) => {
  const {
    canRenderNameSubtitle,
    name
  } = useName();
  if (canRenderNameSubtitle) {
    return /*#__PURE__*/_jsx(StepSubtitle, {
      message: translation,
      messageOptions: {
        name
      }
    });
  }
  return null;
};